import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnalyticsDashboardComponent } from './analytics-dashboard.component';
import { MaterialModule } from "src/app/shared/material/material.module";
import { AnalyticsDashboardRoutingModule } from './analytics-dashboard-routing.module';
import { ChSkeletonComponent } from '../shared/ch-skeleton/ch-skeleton.component';

@NgModule({
  declarations: [
    AnalyticsDashboardComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    AnalyticsDashboardRoutingModule,
    ChSkeletonComponent
  ],
  exports:[
    AnalyticsDashboardComponent
  ]
})
export class AnalyticsDashboardModule { }
